module.exports = __webpack_public_path__ + "static/teddybike2-1b98712ab8f1ca88eeab556c8d6291cb.png";